import { Event } from "../Event"

export class UserNewEmailEvents extends Event {
    public onBlur = async (value: any, setField: any, setState: any) => {
        
    }
}